// Action types
export const FETCH_SUBSCRIPTION_REQUEST = 'FETCH_SUBSCRIPTION_REQUEST'
export const FETCH_SUBSCRIPTION_SUCCESS = 'FETCH_SUBSCRIPTION_SUCCESS'
export const FETCH_SUBSCRIPTION_FAILURE = 'FETCH_SUBSCRIPTION_FAILURE'
export const CLEAR_SUBSCRIPTION = 'CLEAR_SUBSCRIPTION'

// Initial state
const initialState = {
  data: null,   // { status, plan, billing_cycle, trial_end, next_billing_date, cancelled_at, max_users, allowed_languages }
  loading: false,
  error: null,
}

// Reducer
const subscriptionReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SUBSCRIPTION_REQUEST:
      return { ...state, loading: true, error: null }
    case FETCH_SUBSCRIPTION_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: null }
    case FETCH_SUBSCRIPTION_FAILURE:
      return { ...state, loading: false, error: action.payload }
    case CLEAR_SUBSCRIPTION:
      return initialState
    default:
      return state
  }
}

export default subscriptionReducer
